<template>
	<div>
		<modal-primeira-etapa-filtros
			@filtrar="buscarItemProcessoListagem"
			@limpar="limparListagem"
			@limpar-page="limparListagemPaginacao"
			:tem-item-selecionado="itensSelecionadosCount > 0"
		></modal-primeira-etapa-filtros>
		<v-row>
			<v-col cols="12">
				<template-listagem-vazia
					:total-itens="totalItens"
					:textos="textosDoTemplateDaListagemVazia"
				></template-listagem-vazia>
				<painel-com-tabs-sem-rotas :tabs="tabs" class="tab-itens-processos" v-if="temProcessoSelecionado()">
					<template #todoscontador> ({{ totalItens }})</template>
					<template #todos>
						<primeira-etapa-listagem
							:total-paginas="totalPaginas"
							:total-itens="totalItens"
							:paginacao="paginacao"
							:itensProcessos="datasource"
							@paginar="paginarItensProcessoListagem"
							@resetar-page="resetarPaginacaoItensAtaListagem"
							@limparProcessosSelecionados="limparItensProcessosSelecionados"
						></primeira-etapa-listagem>
					</template>
					<template #selecionadoscontador> ({{ itensSelecionadosCount }})</template>
					<template #selecionados>
						<selecionados-listagem></selecionados-listagem>
					</template>
				</painel-com-tabs-sem-rotas>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { actionTypes, getterTypes } from '@/core/constants'
import mutationTypes from '@/core/constants/mutation-types'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import ModalPrimeiraEtapaFiltros from '@/views/pages/ata/gerar-ata/com-processo/modal/primeira-etapa/filtros/ModalPrimeiraEtapaFiltros.vue'
import primeiraEtapaListagem from '@/views/pages/ata/gerar-ata/com-processo/modal/primeira-etapa/listagem/ModalPrimeiraEtapaListagem.vue'
import PainelComTabsSemRotas from '@/views/components/PainelComTabsSemRotas.vue'
import { TabSemRotaUtils } from '@/core/utils'
import { mapGetters, mapState } from 'vuex'
import SelecionadosListagem from '@/views/pages/ata/gerar-ata/com-processo/modal/primeira-etapa/selecionados/SelecionadosListagem.vue'

export default {
	name: 'modal-primeira-etapa',
	components: {
		SelecionadosListagem,
		PainelComTabsSemRotas,
		ModalPrimeiraEtapaFiltros,
		primeiraEtapaListagem,
	},
	data() {
		return {
			datasource: [],
			totalPaginas: 0,
			totalItens: 0,
			paginacao: paginacaoListagem(['idProcesso']),
			tabs: [
				new TabSemRotaUtils(1, 'Todos', 'todos'),
				new TabSemRotaUtils(2, 'Selecionados', 'selecionados', () => {
					return this.itensSelecionadosCount > 0
				}),
			],
			textosDoTemplateDaListagemVazia: {
				titulo: 'Você não possui processo selecionado',
				mensagen: 'Busque para começar',
			},
		}
	},
	computed: {
		...mapGetters({
			itensSelecionadosCount: getterTypes.ITEM_ATA.ITENS_SELECIONADOS_COUNT,
		}),
		...mapState({
			filtros: (state) => state.itemProcesso.filtro,
			filtroProcesso: (state) => state.processo.filtro,
		}),
	},
	created() {
		this.$store.commit(mutationTypes.ITEM_PROCESSO.LIMPAR_FILTRO_LISTAGEM)
		this.$store.commit(mutationTypes.ITEM_ATA.LIMPAR_ITENS_PARA_ADICIONAR, [])
	},
	methods: {
		temProcessoSelecionado() {
			return this.totalItens > 0
		},

		async buscarItemProcessoListagem(payload) {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_PROCESSO.BUSCAR_ITENS_PROCESSOS_LISTAGEM,
				payload,
			)

			this.datasource = this.getListaItensProcessosComIds(itens)
			this.totalItens = totalElements
			this.totalPaginas = totalPages

			if (this.totalItens > 0) {
				const idProcesso = this.datasource[0]?.idProcesso
				const numero = this.datasource[0]?.processoNumero
				const ano = this.datasource[0]?.anoProcesso
				const uoSigla = this.datasource[0]?.uoSiglaProcesso
				const idUo = this.datasource[0]?.idUoProcesso
				const idOrgaoGestorArp = this.datasource[0]?.idOrgaoGestorArp || this.filtros.processo?.idOrgaoGestorArp

				this.filtros.idProcesso = idProcesso
				this.filtros.ano = ano
				this.filtros.orgao = {
					id: idUo,
					sigla: uoSigla,
				}
				this.filtros.processo = {
					id: idProcesso,
					numero: numero,
					anoProcesso: ano,
					uoSiglaProcesso: uoSigla,
					idUoProcesso: idUo,
					idOrgaoGestorArp: idOrgaoGestorArp,
				}
			}
		},
		async paginarItensProcessoListagem(paginacao) {
			this.setPaginacaoItensAtaListagem(paginacao)
			await this.buscarItemProcessoListagem()
		},
		resetarPaginacaoItensAtaListagem() {
			this.$store.commit(mutationTypes.ITEM_PROCESSO.RESETAR_PAGINA_LISTAGEM)
		},
		setPaginacaoItensAtaListagem(paginacao) {
			this.$store.commit(mutationTypes.ITEM_PROCESSO.SET_PAGINACAO_LISTAGEM, paginacao)
		},
		getListaItensProcessosComIds(lista) {
			return lista.map((item, index) => {
				return {
					...item,
					id: (this.$store.state.itemProcesso.paginacao.page - 1) * 5 + index,
					selecionado: this.$store.getters.isSelecionado(item),
				}
			})
		},
		limparItensProcessosSelecionados() {
			this.$store.commit(mutationTypes.ITEM_ATA.LIMPAR_ITENS_PARA_ADICIONAR, [])
		},
		limparListagem() {
			this.datasource = []
			this.totalItens = 0
			this.totalPaginas = 0
		},
		limparListagemPaginacao() {
			this.$store.state.itemProcesso.paginacao.page = 1
		},
	},
}
</script>
<style lang="stylus"></style>
